import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { BulkOrder } from '@app/core/models/bulk-upload.model';
import { Store } from '@ngrx/store';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { AppState, BulkOrdersActionTypes, getBulkOrders, selectBulkOrdersReview, selectProfile } from '@app/core/ngrx';
import { MatSort } from '@angular/material/sort';
import { DatePipe } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ecp-bulk-order-review',
  templateUrl: './bulk-order-review.component.html',
  styleUrls: ['./bulk-order-review.component.scss'],
})
export class BulkOrderReviewComponent implements OnInit {
  ecpLocations: any = [];
  bulkOrderData: any = new MatTableDataSource(null);
  bulkOrders$: Observable<BulkOrder>;
  bulkOrderColumns: string[] = [
    'fdAccountNumber',
    'upc',
    'patientName',
    'rxOrderId',
    'poNumber',
    'uploadedBy',
    'processedOn',
    'frameStatus',
    'frameStatusDate',
  ];
  orderFrom: any = null;
  orderTo: any = null;
  showNoResult: boolean = true;
  defaultFilter?: (data: any, filter: string) => boolean;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private store: Store<AppState>, public datePipe: DatePipe) {
    this.store.select(selectProfile).subscribe(res => {
      let ecpLoc = res.locations.map(e => e.trim());
      this.ecpLocations = ['All', ...ecpLoc];
    });
    let dateNow = new Date();
    let dateFrom = new Date(new Date().setDate(dateNow.getDate() - 30));

    this.orderFrom = dateFrom.toISOString();
    this.orderTo = dateNow.toISOString();

    this.getOrderListDate();
  }

  ngOnInit(): void {
    this.defaultFilter = this.bulkOrderData.filterPredicate;
  }
  getOrderListDate() {
    let payload = {
      fromDate: this.orderFrom,
      toDate: this.orderTo,
    };
    this.submitOrderReview(payload);
  }
  applyFilter(event: Event) {
    this.bulkOrderFilterColumn(false);
    const filterValue = (event.target as HTMLInputElement).value;
    this.bulkOrderData.filter = filterValue.trim().toLowerCase();
    if (this.bulkOrderData.paginator) {
      this.bulkOrderData.paginator.firstPage();
    }
  }
  bulkOrderFilterColumn(isDropDown: boolean) {
    if (isDropDown) {
      this.bulkOrderData.filterPredicate = function(data: any, filter: string): boolean {
        return data.fdAccountNumber.toLowerCase().includes(filter);
      };
    } else {
      this.bulkOrderData.filterPredicate = function(data: any, filter: string): boolean {
        return (
          data?.frameStatus?.toLowerCase().includes(filter) ||
          data?.upc?.toLowerCase().includes(filter) ||
          data?.fdAccountNumber?.toLowerCase().includes(filter) ||
          data?.patientName?.toLowerCase().includes(filter) ||
          data?.rxOrderId?.toLowerCase().includes(filter) ||
          data?.uploadedBy?.toLowerCase().includes(filter) ||
          data.poNumber.toLowerCase().includes(filter)
        );
      };
    }
  }
  filterLocation(ev: any) {
    this.bulkOrderFilterColumn(true);
    const filterValue = ev.value;
    if (filterValue.toLowerCase() === 'all') {
      this.bulkOrderData.filter = '';
    } else {
      this.bulkOrderData.filter = filterValue.trim().toLowerCase();
    }
  }
  submitOrderReview(data: any) {
    this.store.dispatch({ type: BulkOrdersActionTypes.LOAD_BULK_ORDERS_REVIEW, payload: data });
    this.bulkOrders$ = this.store.select(selectBulkOrdersReview);
    this.bulkOrders$.subscribe(
      (order: any) => {
        if (order) {
          let bulkData = order.orderItems.map(res => {
            return {
              fdAccountNumber: res.fdAccountNumber,
              upc: res.upc,
              patientName:
                !res.patientFirstname && !res.patientLastName ? '' : res.patientFirstname + ' ' + res.patientLastName,
              rxOrderId: res.rxOrderId,
              poNumber: res.poNumber,
              uploadedBy: res.uploadedBy,
              processedOn: res.processedOn,
              frameStatus: res.frameStatus,
              frameStatusDate: res.frameStatusDate,
            };
          });
          this.bulkOrderData = new MatTableDataSource(bulkData);
          this.bulkOrderData.sort = this.sort;
          this.bulkOrderData.paginator = this.paginator;
          this.showNoResult = false;
        } else {
          this.bulkOrderData = new MatTableDataSource(null);
          this.showNoResult = true;
        }
      },
      err => {
        console.log(err);
      },
    );
  }
  formatFileName(title: string) {
    return title.replace(/[_-]/g, ' ');
  }

  parseProcessDate(proDate: any) {
    let nDate = new Date(proDate);
    let nYearDate = nDate.getFullYear();
    if (nYearDate !== 1) {
      return proDate;
    }
  }

  downloadOrders() {
    const reportDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    var formatted = JSON.stringify(this.bulkOrderData.filteredData)
      .replace(/fdAccountNumber/g, 'Account Number')
      .replace(/upc/g, 'UPC')
      .replace(/patientName/g, 'Patient Name')
      .replace(/rxOrderId/g, 'Rx Order Id')
      .replace(/poNumber/g, 'PO Number')
      .replace(/uploadedBy/g, 'Uploaded By')
      .replace(/processedOn/g, 'Processed On')
      .replace(/frameStatus/g, 'Frame Status')
      .replace(/frameStatusDate/g, 'Latest Frame Status Date');
    const reportSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(JSON.parse(formatted));
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, reportSheet, 'Order Report');
    XLSX.writeFile(wb, 'Bulk Order Review -' + reportDate + '.xlsx');
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
